import { render, staticRenderFns } from "./SupplierLogo.vue?vue&type=template&id=a0787310"
import script from "./SupplierLogo.vue?vue&type=script&lang=js"
export * from "./SupplierLogo.vue?vue&type=script&lang=js"
import style0 from "./SupplierLogo.vue?vue&type=style&index=0&id=a0787310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../acquisition-home/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports